import { Layout } from "antd";
import { Outlet } from "react-router-dom";

import Breadcrumbs from "../Breadcrumbs";

const { Content, Footer } = Layout;

const LoginLayout = () => {
  return (
    <>
      <Layout style={{ minHeight: "100vh" }}>
        <Content
          style={{
            marginTop: 80,
            padding: "0 50px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              color: "#00000073",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Breadcrumbs />
          </div>

          <Outlet />
        </Content>
        <Footer style={{ textAlign: "center" }}>Created by prenode GmbH</Footer>
      </Layout>
    </>
  );
};

export default LoginLayout;
